import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

interface MdaPageHeaderProps {
  markAsReadDisabled: boolean;
  markAsReadLoading: boolean;
  onMarkAsRead: () => Promise<void>;
  // Hidden on the landing step, where there are no claims to request yet.
  showRequestSpreadsheet?: boolean;
}

const MdaPageHeader = ({
  markAsReadDisabled,
  markAsReadLoading,
  onMarkAsRead,
  showRequestSpreadsheet = true,
}: MdaPageHeaderProps) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    justifyContent="space-between"
    spacing={2}
    sx={{ mb: 3 }}
  >
    <Box>
      <Typography
        component="h1"
        sx={{
          color: "#12233f",
          fontSize: { xs: "1.65rem", sm: "2rem" },
          fontWeight: 700,
          letterSpacing: 0,
        }}
      >
        Claims
      </Typography>
      <Typography sx={{ color: "#66758b", mt: 0.5 }}>
        View and manage all claims across your clients.
      </Typography>
    </Box>
    {showRequestSpreadsheet && (
      <Button
        disabled={markAsReadDisabled || markAsReadLoading}
        onClick={onMarkAsRead}
        startIcon={
          markAsReadLoading ? (
            <CircularProgress color="inherit" size={16} />
          ) : (
            <FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />
          )
        }
        sx={{
          alignSelf: { xs: "flex-start", sm: "center" },
          border: "1px solid #8bb2ff",
          borderRadius: 1,
          color: "#1769ff",
          fontWeight: 700,
          px: 2,
          py: 1,
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#f3f7ff",
            borderColor: "#1769ff",
          },
        }}
      >
        Request Spreadsheet & Mark All as Read
      </Button>
    )}
  </Stack>
);

export default MdaPageHeader;
